// extracted by mini-css-extract-plugin
module.exports = {"ContentWrapper":"ContentWrapper","contentWrapper":"contentWrapper","PageContent":"PageContent","pageContent":"pageContent","mobile":"mobile","Footer":"Footer","footer":"Footer"};